import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { SystemMessage } from '@portal-core/system-messages/models/system-message.model';

@CollectionStateSelectors({
  stateType: SystemMessagesState
})
@State<SystemMessagesState>({
  name: SystemMessagesState.source
})
@Service({ autoProvided: false })
export class SystemMessagesState extends CollectionStateBase {
  static override source = 'SystemMessages';
  getSource(): string {
    return SystemMessagesState.source;
  }
}
@Service()
export class SystemMessagesDataService extends CollectionDataServiceBase<SystemMessage> {
  protected readonly stateType = SystemMessagesState;
}
